import {NavigateFunction} from "react-router-dom";

const logout = (navigate: NavigateFunction) => {
  return navigate(`/logout`);
};

export const goto = {
  logout: logout,
};
